module.exports = __webpack_public_path__ + "fonts/inter-v20-latin-700.8ca0a515.woff2";